module.exports = __webpack_public_path__ + "assets/img/36_506_big.8b33dc95.jpg";